import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import { notifySomething } from '../_Utils/AppDocuCommon';
import EditPaperDialog from '../Paper_Components/EditPaperDialog';

class ActionsFormatter extends React.Component {
  deleteService = async (itemId) => {
    if (!window.confirm('Delete this paper?')) return;
    try {
      const res = await AppDocuServiceCall.deletePaper(itemId);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error deleting paper', 'error');
        return;
      }
      await this.props.onItemsChange();
    } catch (error) {
      console.error('Error deleting paper:', error);
      notifySomething('Error deleting paper', 'error');
    }
  };

  render() {
    const { row, onOpenEditDialog } = this.props;
    return (
      <div style={{ display: 'flex', gap: 0, alignItems: 'center', minWidth: 60 }}>
        <Tooltip title="Edit">
          <IconButton size="small" onClick={() => onOpenEditDialog && onOpenEditDialog(row)} style={{ padding: 4 }}>
            <EditIcon style={{ color: '#111', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton size="small" onClick={() => this.deleteService(row.id)} style={{ padding: 4 }}>
            <DeleteIcon style={{ color: 'darkred', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      </div>
    );
  }
}

export default class PaperActionsTypeProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemDataToEdit: /** @type {any} */ (null),
    };
  }

  render() {
    const { for: forColumns, ...rest } = this.props;
    return (
      <>
        <DataTypeProvider
          formatterComponent={props => (
            <ActionsFormatter
              row={props.row}
              onOpenEditDialog={row => this.setState({ itemDataToEdit: row })}
              onItemsChange={this.props.onItemsChange}
            />
          )}
          for={forColumns}
          {...rest}
        />
        <EditPaperDialog
          itemId={this.state.itemDataToEdit ? this.state.itemDataToEdit.id : null}
          onClose={() => this.setState({ itemDataToEdit: null })}
          onItemsChange={this.props.onItemsChange}
        />
      </>
    );
  }
}
